(() => {
  const initVideo = (video) => {
    if (video.dataset.heroVideoInitialized) return;
    video.dataset.heroVideoInitialized = 'true';

    const wrapper = video.closest('.hero__media-wrapper');
    const button = wrapper ? wrapper.querySelector('[data-hero-video-toggle]') : null;

    const update = (playing) => {
      if (!wrapper) return;
      wrapper.classList.toggle('is-playing', playing);
    };

    if (button) {
      button.addEventListener('click', () => {
        if (video.paused) {
          video.play().then(() => update(true)).catch(() => {});
        } else {
          video.pause();
          update(false);
        }
      });
    }

    if (video.hasAttribute('data-hero-video-lazy')) {
      let started = false;
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          if (started) {
            io.disconnect();
            return;
          }
          video
            .play()
            .then(() => {
              started = true;
              update(true);
              io.disconnect();
            })
            .catch(() => {
              // transient rejection (e.g. background-tab power save) — retry on next intersection
            });
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(video);
    }

    video.addEventListener('play', () => update(true));
    video.addEventListener('pause', () => update(false));
  };

  const scan = (root) => {
    root.querySelectorAll('video[data-hero-video]').forEach(initVideo);
  };

  scan(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('video[data-hero-video]')) {
          initVideo(node);
        }
        scan(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
